import { z } from "zod";

const PENDING_EVENT_KEY = "events-admin:pending-event";
export const MINIMUM_TRAVELER_COUNT = 50;

const agreementWorkflowSchema = z.object({
  eventId: z.string(),
  templateContractId: z.string(),
  requestId: z.string(),
  step: z.enum(["CONFIGURING", "SIGNING"]),
  values: z.record(z.string(), z.string()),
  typedSignature: z.string().optional(),
  previewHash: z.string().optional(),
  previewAcceptedAt: z.string().optional(),
  previewRenderVersion: z.string().optional(),
});

export const pendingEventSchema = z.object({
  eventName: z.string(),
  eventType: z.string(),
  organizerName: z.string(),
  organizerEmail: z.string(),
  venueName: z.string(),
  venueAddress: z.string(),
  description: z.string(),
  destinationLabel: z.string(),
  primaryAirportCode: z.string(),
  departDate: z.string(),
  returnDate: z.string(),
  passengers: z.string(),
  agreementWorkflow: agreementWorkflowSchema.optional(),
});

export type PendingEventFormValues = z.infer<typeof pendingEventSchema>;

export function savePendingEvent(values: PendingEventFormValues): void {
  try {
    sessionStorage.setItem(PENDING_EVENT_KEY, JSON.stringify(values));
  } catch {
    // sessionStorage may be unavailable in some browsers
  }
}

export function loadPendingEvent(): PendingEventFormValues | null {
  try {
    const raw = sessionStorage.getItem(PENDING_EVENT_KEY);
    if (!raw) return null;
    const parsed = pendingEventSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function clearPendingEvent(): void {
  try {
    sessionStorage.removeItem(PENDING_EVENT_KEY);
  } catch {
    // noop
  }
}
